var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.294 19.7911C29.294 22.7281 26.9391 25.0831 24 25.0831C21.0619 25.0831 18.706 22.7281 18.706 19.7911C18.706 16.854 21.0619 14.5 24 14.5C26.9391 14.5 29.294 16.854 29.294 19.7911ZM24 34.5C19.6624 34.5 16 33.795 16 31.075C16 28.3539 19.6854 27.6739 24 27.6739C28.3386 27.6739 32 28.3789 32 31.099C32 33.82 28.3146 34.5 24 34.5Z",
    fill: "#0F0F0F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Profile.7940ba63.svg";
export { ForwardRef as ReactComponent };